<template>
  <div class="d-inline-flex align-center">
    <span class="locomotion-filter-label mr-3">{{ term('station.locomotion') }}</span>
    <v-btn-toggle
      :value="locomotion"
      mandatory
      dense
      color="primary"
      data-testid="locomotion-filter"
      :aria-label="term('station.locomotion_filter.label')"
      @change="value => $emit('change', value)"
    >
      <v-btn
        v-for="option in options"
        :key="option.value"
        :value="option.value"
        small
      >{{ option.label }}</v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
import LocalizedTerms from '@/mixins/localizedTerms';
import { LOCOMOTION_FLYING, LOCOMOTION_CRAWLING } from '@/libs/insectTypes';

export default {
  name: 'locomotion-filter',
  mixins: [LocalizedTerms],
  model: {
    prop: 'locomotion',
    event: 'change',
  },
  props: {
    locomotion: {
      type: String,
      default: 'all',
      validator: (value) => ['all', LOCOMOTION_FLYING, LOCOMOTION_CRAWLING].includes(value),
    },
  },
  computed: {
    options() {
      return [
        { value: 'all', label: this.term('station.locomotion_filter.all') },
        { value: LOCOMOTION_FLYING, label: this.term('station.locomotion_label.flying') },
        { value: LOCOMOTION_CRAWLING, label: this.term('station.locomotion_label.crawling') },
      ];
    },
  },
};
</script>
<style lang="sass" scoped>
.locomotion-filter-label
  font-size: 13px
  color: rgba(0, 0, 0, 0.6)
</style>
